package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.di.koinGet
import io.horion.cv.models.LanguageState
import io.horion.cv.viewModel.CvViewModel
import org.jetbrains.compose.web.css.px

@Composable
fun LanguageAccordionContent(
    onComplete: (String) -> Unit,
    onAddCompetenceAndClose: (String) -> Unit
) {
    val cvViewModel = koinGet<CvViewModel>()
    val languagesFromVM = cvViewModel.cvUiState.data.languages

    LaunchedEffect(Unit) {
        if (languagesFromVM.isEmpty()) {
            cvViewModel.updateLanguage(0, name = "", level = "")
            cvViewModel.editingLanguageId = "langue-0"
        }
    }

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(30.px)
    ) {
        languagesFromVM.forEachIndexed { index, langItem ->
            val tempId = "langue-$index"
            val state = remember(langItem) {
                LanguageState(id = tempId, langue = langItem.language.name, niveau = langItem.level.name)
            }

            GenericFormCard(
                item = state,
                isEditing = cvViewModel.editingLanguageId == tempId,
                onEdit = { cvViewModel.editingLanguageId = tempId },
                onDelete = {
                    cvViewModel.deleteLanguage(index)
                    if (cvViewModel.cvUiState.data.languages.isEmpty()) {
                        cvViewModel.updateLanguage(0, "", "")
                        cvViewModel.editingLanguageId = "langue-0"
                    }
                },
                onComplete = { cvViewModel.editingLanguageId = null },
                getSummary = { l ->
                    if (l.langue.isNotBlank()) SummaryData(l.langue, l.niveau) else null
                },
                getDefaultText = { "[Langue]" },
                formContent = { s, onDel, onComp ->
                    LanguageForm(
                        index = index,
                        state = s,
                        cvViewModel = cvViewModel,
                        onDelete = onDel,
                        onComplete = onComp
                    )
                }
            )
        }
        AddButton(
            text = "Ajouter une langue",
            onClick = {
            val nextIndex = languagesFromVM.size
                cvViewModel.updateLanguage(nextIndex, name = "", level = "")
                cvViewModel.editingLanguageId = "langue-$nextIndex"
            }
        )
    }
}